module.exports = {
  message: {
    "Account": 'Account management',
    "User List": "User Listing",
    "Role List": "Role Listing",
    "userName": "Username",
    "Status": "Status",
    "Search": "Search",
    "datagridresult": " results in total",
    "RoleName": "Role Name",
    "createdTime": "Created date",
    "Add": "Add",
    "Delete": "Delete",
    "password": "Password",
    "Tel": "Telephone",
    "email": "Email",
    "Role": "Role",
    "Active": "Active",
    "Inactive": "Inactive",
    "Save": "Save",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Warning": "Warning",
    "RoleType": "Role type",
    "passwordFormat": "Enter a 8-15 characters password which can include letter(s) and/or number(s). ",
    "Super Admin": "Super Admin",
    "Platform": "Platform",
    "FunctionSelection": "Function & Feature",
    "All": "--- All ---",
    "selectDefault": "--- Default ---",
    "PleaseSelect": "--- Please Select ---",
    "title": "Title",
    "LogOut": "Logout",
    "name": "Name",
    "English": "English",
    "Simplified Chinese": "Simplified Chinese",
    "Traditional Chinese": "Traditional Chinese",
    "en_US": "English",
    "zh_CN": "Simplified Chinese",
    "zh_HK": "Traditional Chinese",
    "HomePage": "Home page",
    "userDetail": "User details",
    "roleDetail": "Role details",
    "Publish": "Publish",
    "Draft": "Draft",
    "Published": "Published",
    "Preview": "Preview",
    "Edit": "Edit",
    "Tags": "Tags",
    "Add tag": "Add tag",
    "Image size error": "Image size error!",
    "Dimension Error": "Dimension Error!",
    "deleteContent": "Are you sure to delete the selected content?",
    "Home": "Home",
    "Event": "Event",
    "Highlights": "Highlights",
    "Event Group List": "Event Group List",
    "Event List": "Event List",
    "Tag": "Tag",
    "Tag List": "Tag List",
    "Event Group Detail": "Event Group Detail",
    "Tag Detail": "Tag Detail",
    "synonyms": "Synonyms",
    "id": "ID",
    "Group Title - Eng": "Group Title - Eng",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "Rearrange Order": "Rearrange Order",
    "Group Title": "Group Title",
    "eventId": "EventId",
    "Group Types": "Group Types",
    "Event Types": "Event Types",
    "venue": "Venue",
    "highlights": "highlights",
    "Group TitleTChi": "Group Title - T.Chi",
    "Group TitleSChi": "Group Title - S.Chi",
    "Series": "Series",
    "Package": "Package",
    "Festival": "Festival",
    "Unpublish": "Unpublish",
    "Xiqu Centre": "Xiqu Centre",
    "Freespace": "Freespace",
    "Art Park": "Art Park",
    "Multi-venue": "Multi-venue",
    "Out-of-district": "Out-of-district",
    "M+ Pavillian": "M+ Pavillian",
    "order": "Order",
    "Title - Eng": "Title - Eng",
    "TitleTChi": "Title - T.Chi",
    "TitleSChi": "Title - S.Chi",
    "Event Detail": "Event Detail",
    "required": "This field is required",
    "preview": "Preview",
    "Event Search": "Event Search",
    "Hot Tags": "Hot Tags",
    "Hot Events": "Hot Events",
    "Key Visual": "Key Visual",
    "Key Visual & Greeting Message List": "Key Visual & Greeting Message List",
    "keyword": "Keyword",
    "Key Visual Detail": "Key Visual Detail",
    "Landing Page Management": "Landing Page Management",
    "editorial List": "Editorial List",
    "editorial Detail": "editorial Detail",
    "Editorial Management": "Editorial Management",
    "Daily Recommendation": "Daily Recommendation",
    "Editorial List": "Editorial List",
    "Visit Management": "Visit Management",
    "Shop Description": "Shop Description",
    "Dining Description": "Dining Description",
    "Amenities Description": "Attractions Description",
    "Transportation Description": "Transportation Description",
    "Social Media List": "Social Media List",
    "Social Media Detail": "Social Media Detail",
    "Accessibility Statement": "Accessibility Statement",
    "Accessibility App Usages": "Accessibility App Usages",
    "FAQ": "FAQ",
    "About us": "About us",
    'Terms & Conditions': "Terms & Conditions",
    "More Management": "More Management",
    "Hot Editorials": "Hot Editorials",
    "fillRequired": "Please fill in the required information",
    "Tips/Reminders": "Tips/Reminders",
    "Special Announcement": "Special Announcement",
    "Special Announcement Detail": "Special Announcement Detail",
    "Arwiz": "Arwiz",
    "Parking Description": "Parking Description",
    "Freespace Long Description": "Freespace Long Description",
    "Xiqu Centre Long Description": "Xiqu Centre Long Description",
    "Art Park Long Description": "Art Park Long Description",
    "M+ Pavilion Long Description": "M+ Pavilion Long Description",
    "Umbrella Sharing Service": "Umbrella Sharing Service",
    "Water Fountain Service": "Water Fountain Service",
    "Transit Announcement": "Transit Announcement",
    "Promotion Management": "Promotion Management",
    "Promotion List": "Promotion List",
    "Promotion Detail": "Promotion Detail",
    "Entry Banner": "Entry Banner",
    "Arts Pavilion Long Description": "Arts Pavilion Long Description",
    "M+ Long Description": "M+ Long Description",
    "Poi Upload": "POI Upload",
    "POI Upload": "POI Upload",
    "Deactivated Account Management": "Deactivated Account Management",
    "Hong Kong Palace Museum Long Description": "Hong Kong Palace Museum Long Description",
    "Membership": "Membership",
    "Membership management": "Membership management",
    "Member Privilege": "Member Privilege",
    "Membership List": "Membership List",
    "Membership Detail": "Membership Detail",
    "activeTip": "Are you sure to set the record to Active? ",
    "inactiveTip": "Are you sure to set the record to Inactive? ",
    "Member Privilege List": "Member Privilege List",
    "Member Privilege Detail": "Member Privilege Detail",
    "Membership Event": "Membership Event",
    "Landing Page": "Landing Page",
    "Background at the top icon": "Background at the top icon",
    "MyWestK Privilege": "MyWestK Privilege",
    "M+ Member Event": "M+ Member Event",
    "HKPM Member Event": "HKPM Member Event",
    "MyWestK Member Event": "MyWestK Member Event",
    "M+ Member Editorial": "M+ Member Editorial",
    "HKPM Member Editorial": "HKPM Member Editorial",
    "MyWestK Member Editorial": "MyWestK Member Editorial",

  }
}